/** 讀取 Vite 公開環境變數（未設定時為空字串） */
function envPublic(key: string): string {
  const v = (import.meta.env as Record<string, string | undefined>)[key];
  return typeof v === 'string' ? v.trim() : '';
}

/** 對外官網（FB / LINE / 名片請用此網域） */
export const SITE_CANONICAL_URL =
  envPublic('VITE_APP_URL') || 'https://techfix.com.tw';

/** Google Play：正式或封測 opt-in 連結，可用 VITE_PLAY_STORE_URL 覆寫 */
export const PLAY_STORE_URL =
  envPublic('VITE_PLAY_STORE_URL') ||
  'https://play.google.com/store/apps/details?id=com.fixnow.platform';

/** App Store（iOS 過審後設定 VITE_APP_STORE_URL） */
export const APP_STORE_URL = envPublic('VITE_APP_STORE_URL');

export const APP_DOWNLOAD_TAGLINE =
  '手機直接開 techfix.com.tw 就能發案；Android 可下載快修通 App，推播、使用更順。';
